import axios from 'axios'
export default {
    namespaced: true,

    state: {
        facilities: [],
        myFacilities: []
    },

    getters: {
        GetAllFacilities(state) {
            return state.facilities
        },

        GetMyFacilities(state) {
            return state.myFacilities
        },

        GetMyEnabledFacilities(state) {
            return state.myFacilities.filter(f => {
                return f.isActive
            })
        },

        GetAllFacilitiesDisabled(state) {
            return state.myFacilities.every(function (facility) {
                return facility.isActive == false;
            })
        }

    },

    mutations: {
        PUSH_FACILITIES(state, data) {
            state.facilities = data
        },
        
        PUSH_MY_FACILITIES(state, data) {
            state.myFacilities = data
        }
    },

    actions: {
        async GetAllFacilities({commit, rootGetters}) {
            try {
                let response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/facilities/${rootGetters['UserStore/GetUserOrganisationId']}`)
            
                commit('PUSH_FACILITIES', response.data)
            }   
            catch(err) {
                throw new Error(err)
            }
        },

        async GetMyFacilities({commit}) {
            try {
                let response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/facilities/me`)

                commit('PUSH_MY_FACILITIES', response.data)

                return response
            }
            catch(err) {
                throw new Error(err)
            }
        },

        async ReplaceFacility({commit}, id) {
            try {
                let response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/facilities/${id}`)

                commit('UserStore/SET_FACILITY', response.data)
            }
            catch(err) {
                throw new Error(err)
            }
        }
    }
}